module.exports = __webpack_public_path__ + "superman.svg?1793698113381";